import React, { useState } from 'react'
import Mensagem from '../components/Mensagem'

export default function Login(props) {

    const [mensagem, setMensagem] = useState('')
     
    const logar = () => {
        setMensagem({ tipo:'LIMPAR', texto:'' })
        props.setShowSpinner(true)
        if (props.usuarioLogado.login === "55555555555" && props.usuarioLogado.senha === "cgm@usuario") {
            props.setUsuarioLogado({ ...props.usuarioLogado, nome:'Técnico um', logado:true })
            props.setFormularioEmPauta('') 
        } else {
            setMensagem({ tipo:'problema', texto:'credenciais inválidas' })
            props.setShowSpinner(false)
            return
        }
    }

    if (props.formularioEmPauta !== "Login") {
        return null;
    }

    return (
        <div className="molduraLeituraProtocolo">
            <Mensagem mensagem={ mensagem } />
            <br />
            <div className="card" style={{ width:320 }}>
                <div className="card-header"></div>
                <div className="card-body">
                    <div>
                        <label>Login</label>
                        <input 
                            id="idLogin"
                            type="text" 
                            className="form-control mb-3" 
                            placeholder="CPF"
                            value={ props.usuarioLogado.login }
                            onChange={ 
                                event => props.setUsuarioLogado({
                                    ...props.usuarioLogado, 
                                    login:event.target.value
                                }) 
                            }
                        />
                    </div>
                    <div>
                        <label>Senha</label>
                        <input 
                            id="idSenha"
                            type="password" 
                            className="form-control" 
                            placeholder="Senha do RioMail(LDap)"
                            value={ props.usuarioLogado.senha }
                            onChange={ 
                                event => props.setUsuarioLogado({ ...props.usuarioLogado, senha:event.target.value }) 
                            }
                        />
                    </div>
                    <button type="button" className="btn btn-primary mt-4" onClick={ logar }>OK</button>
                </div>
            </div>
        </div>
    )
}
